import { ToWords } from 'to-words';
export function convertNumberToAlpha(num) {
    return String.fromCharCode(65 + num);
}
export function formatCurrency(value) {
    var formattedValue = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
    }).format(value);
    return formattedValue;
}
export var formatStripePlanPrice = function (amount, currency) {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency.toUpperCase(),
    }).format(amount / 100);
};
export var formatStripePlanInterval = function (interval, intervalCount) {
    if (intervalCount === 1) {
        return "per ".concat(interval);
    }
    return "/".concat(intervalCount, " ").concat(interval, "s");
};
export function numberToWords(value, lowercase) {
    if (lowercase === void 0) { lowercase = true; }
    var toWords = new ToWords();
    return lowercase ? toWords.convert(value).toLowerCase() : toWords.convert(value);
}
export var formatPhoneNumber = function (phone) {
    var digits = phone.replace(/\D/g, '');
    if (digits.length === 10) {
        return "(".concat(digits.slice(0, 3), ") ").concat(digits.slice(3, 6), "-").concat(digits.slice(6));
    }
    else if (digits.length === 11 && digits.startsWith('1')) {
        return "(".concat(digits.slice(1, 4), ") ").concat(digits.slice(4, 7), "-").concat(digits.slice(7));
    }
    return phone;
};
